import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_contract_line_details_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { billingContractLineId?: number, strategyFieldName?: string, billingContractId?: number }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, SerializedValueEntity?: string, Value?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contract_line_details_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { billingContractLineId?: number, strategyFieldName?: string, billingContractId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, SerializedValueEntity?: string, Value?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contract_line_details_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { billingContractLineId?: number, strategyFieldName?: string, billingContractId?: number, $keys: { BillingContractLineId?: number, StrategyFieldName?: string }[] }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, SerializedValueEntity?: string, Value?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_contract_line_details_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
